export const categories = [
  {
    id: 'tutorial',
    name: '使用教程',
    slug: 'tutorial',
    description: '详细的使用教程与操作指南，助您快速上手jm天堂',
    icon: 'ri-book-open-line',
    articleCount: 24,
  },
  {
    id: 'faq',
    name: '常见问题',
    slug: 'faq',
    description: '解答您在使用jm天堂过程中遇到的各类问题',
    icon: 'ri-question-answer-line',
    articleCount: 18,
  },
  {
    id: 'news',
    name: '最新动态',
    slug: 'news',
    description: 'jm天堂平台最新更新、公告与动态资讯',
    icon: 'ri-flashlight-line',
    articleCount: 15,
  },
  {
    id: 'resource',
    name: '资源分享',
    slug: 'resource',
    description: '优质内容资源推荐与精选合集分享',
    icon: 'ri-folder-transfer-line',
    articleCount: 32,
  },
  {
    id: 'tips',
    name: '使用技巧',
    slug: 'tips',
    description: '高效使用jm天堂的实用技巧与隐藏功能揭秘',
    icon: 'ri-lightbulb-line',
    articleCount: 20,
  },
  {
    id: 'security',
    name: '安全指南',
    slug: 'security',
    description: '账号安全、隐私保护与安全访问指南',
    icon: 'ri-shield-check-line',
    articleCount: 12,
  },
];

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}